module.exports = __webpack_public_path__ + "img/0128.4c2358fb.png";